













































import Vue from 'vue'
import BasePageTemplate from '@/views/templates/africadogs/BasePageTemplate.vue'
import ScrollFire from '@/views/mixin/ScrollFire'

Vue.mixin(ScrollFire)

export default
  components: {
    BasePageTemplate
  }

  data: () ->
    showMovie: false
    showQuiz: 0
    isSuccess: false
    fire_scroll: true
    youtubeURL: 'https://www.youtube-nocookie.com/embed/G0pphIz0WnU'

  created: () ->
    @$options.scroll_target = '.episode1'

  methods: {
    scrollFire: () ->
      if @showQuiz == 0
        @showQuiz = 1
    reshow_quiz: () ->
      @showQuiz = 1
    closeQuiz: () ->
      if @isSuccess
        @showQuiz = 3
      else
        @showQuiz = 2
    openYoutube: () ->
      window.open @youtubeURL
    addPoint: (point) ->
      @$emit('addPoint', point)
    success: () ->
      @isSuccess = true
  }

